export class EfficiencyCosts {
  perOccupiedHourCost: number;
  hoursUnoccupiedInbound: number;
  hoursOccupied: number;
  hoursUnoccupiedOutbound: number;
}